import { getAreasApi } from "../../../api/get/getAreasApi";
import { setAreas } from "./countrySlice";

// Thunk to fetch and set delivery zones
export const fetchAreas = () => async (dispatch) => {
  try {
    const zones = await getAreasApi();
    dispatch(setAreas(zones.data));
  } catch (error) {
    console.error("Fetching areas failed:", error);
  }
};
